import { render, staticRenderFns } from "./milling.vue?vue&type=template&id=3b85c71d"
import script from "./milling.vue?vue&type=script&lang=js"
export * from "./milling.vue?vue&type=script&lang=js"
import style0 from "./milling.vue?vue&type=style&index=0&id=3b85c71d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports